import { Fragment } from 'react'
import { Col, Container, Row } from 'reactstrap'
import Breadcrumbs from '../../../CommonElements/Breadcrumbs'
import { onlineOrderCardData } from '../../../Data/WidgetsData/GeneralData'
import ActiveTasksCard from '../../../Utils/CommonComponents/DashboardsCommon/DefaultCommon/ActiveTasksCard'
import TotalEarningCards from '../../../Utils/CommonComponents/DashboardsCommon/DefaultCommon/TotalEarningCards'
import CategoriesBySales from '../../../Utils/CommonComponents/DashboardsCommon/EcommerceCommon/CategoriesBySales'
import OnlineOrderCards from '../../../Utils/CommonComponents/DashboardsCommon/EcommerceCommon/OnlineOrderCards'
import OrderOverviewMonthlyInvoiceCards from '../../../Utils/CommonComponents/DashboardsCommon/EcommerceCommon/OrderOverviewMonthlyInvoiceCards'
import BudgetCard from '../../../Utils/CommonComponents/DashboardsCommon/ProjectCommon/BudgetCard'
import ProjectCreated from '../../../Utils/CommonComponents/DashboardsCommon/ProjectCommon/ProjectCreated'
import WebCard from '../../../Utils/CommonComponents/DashboardsCommon/ProjectCommon/WebCard'
import { GeneralTitle, WidgetsTitle } from '../../../Utils/Constants'
import CustomerDiscountCards from './CustomerDiscountCards'

export default function GeneralWidgets() {
    return (
        <Fragment>
            <Breadcrumbs pageTitle={GeneralTitle} parent={WidgetsTitle} title={GeneralTitle} />
            <Container fluid className="general-widget">
                <Row>
                    <WebCard/>
                    <CategoriesBySales />
                    <ProjectCreated colClass='col-xl-6 col-lg-6' />
                    <BudgetCard colClass='col-xl-3 col-xl-40 col-lg-4 col-md-12 box-col-4' />
                    <Col xl={6} className="col-xl-70 box-col-8e">
                        <OrderOverviewMonthlyInvoiceCards colClass='col-lg-12 col-md-12 col-sm-6' />
                    </Col>
                    <CustomerDiscountCards />
                    <Col lg={4}>
                        <TotalEarningCards colClass='col-sm-6' />
                    </Col>
                    <ActiveTasksCard colClass='col-xl-4 col-xl-40 col-md-6 box-col-4' />
                    <OnlineOrderCards data={onlineOrderCardData} />
                </Row>
            </Container>
        </Fragment>
    )
}
